/**
 * @file This file contains the BannerManager class for showing large, temporary on-screen announcements.
 * @module BannerManager
 */

export class BannerManager {
    /**
     * @param {object} dependencies - The dependencies for the manager.
     * @param {HTMLElement} dependencies.bannerOverlay - The DOM element to render banners into.
     */
    constructor({ bannerOverlay }) {
        this.overlay = bannerOverlay;
    }

    /**
     * Displays a banner with the given content for a specified duration.
     * @param {string} content - The HTML content to display in the banner.
     * @param {number} [duration=3000] - The duration in milliseconds to show the banner.
     */
    show(content, duration = 3000) {
        const banner = document.createElement('div');
        banner.className = 'banner';
        banner.innerHTML = `<h2>${content}</h2>`;
        this.overlay.appendChild(banner);

        setTimeout(() => banner.classList.add('visible'), 50); // Allow for CSS transition

        setTimeout(() => banner.remove(), duration);
    }
}